import { type ReactNode, useState } from 'react';
import { PREPIONEERS_TOTAL } from '../founders-config';
import { FoundersJump } from './founders-jump';
import { PrepioneersHero } from './prepioneers-hero';
import { PrepioneersGrid, scrollToPrepioneer } from './prepioneers-grid';

export function PrepioneersPage(): ReactNode {
  const [start, setStart] = useState(1);
  // Same number twice = no remount, so scroll by hand.
  const onJump = (n: number): void =>
    n === start ? scrollToPrepioneer(n) : setStart(n);
  return (
    <div className="space-y-lg">
      <PrepioneersHero />
      <FoundersJump
        total={PREPIONEERS_TOTAL}
        onJump={onJump}
        placeholder="250000"
      />
      <PrepioneersGrid key={start} start={start} />
    </div>
  );
}
